/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'fast-forward-circle': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M8 15A7 7 0 118 1a7 7 0 010 14m0 1A8 8 0 108 0a8 8 0 000 16"/><path pid="1" d="M4.271 5.055a.5.5 0 01.52.038L8 7.386V5.5a.5.5 0 01.79-.407l3.5 2.5a.5.5 0 010 .814l-3.5 2.5A.5.5 0 018 10.5V8.614l-3.21 2.293A.5.5 0 014 10.5v-5a.5.5 0 01.271-.445"/>',
    },
});
